<div class="w-full" #contractSectionWidthRef></div>
@if (initialized && dto) {
    @if (uiMode == 'inline') {
        <cm-contract-object-inline-component
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [viewType]="viewType"
        ></cm-contract-object-inline-component>
    } @else if (uiMode == 'consultant') {
        <mvs-cm-contract-consultant
                [objectIdentifier]="objectIdentifier"
                [viewType]="viewType"
        ></mvs-cm-contract-consultant>
    } @else if (uiMode == 'side') {
        <div class="">
            <cm-contract-object-side-component
                    [dto]="dto"
                    [transientDto]="dto"
                    [objectIdentifier]="objectIdentifier"
                    [uiMode]="uiMode"
                    [activeNavigationItem]="activeNavigationItems"
                    (onNavigationItems)="handleNavigationItems($event)"
                    (onTicketCreate)="customFunction()"
            ></cm-contract-object-side-component>
        </div>
    } @else if (uiMode == 'mini-side') {
        <div class="">
            <cm-contract-object-mini-side-component
                    [dto]="dto"
                    [transientDto]="dto"
                    [objectIdentifier]="objectIdentifier"
                    [uiMode]="uiMode"
                    [activeNavigationItem]="activeNavigationItems"
                    (onNavigationItems)="handleNavigationItems($event)"
                    (onTicketCreate)="customFunction()"
            ></cm-contract-object-mini-side-component>
        </div>
    } @else {
        <cm-contract-object-full-component
                [dto]="dto"
                [transientDto]="dto"
                [objectIdentifier]="objectIdentifier"
                [uiMode]="uiMode"
                [activeNavigationItem]="activeNavigationItems"
                (onNavigationItems)="handleNavigationItems($event)"
                (onTicketCreate)="customFunction()"
        ></cm-contract-object-full-component>
    }
}
<!-- TM-1000002015: quick actions offered to the leading slot of the navigation icon row (panel only) -->
<ng-template #navigationLeading>
    @if (dto && objectIdentifier?.objectId) {
        <cm-contract-quick-actions
                [contractDto]="dto"
                [objectIdentifier]="objectIdentifier"
                triggerStyleClass="h-2rem w-2rem p-0"
                (contractChanged)="refreshObject(false)"
        ></cm-contract-quick-actions>
    }
</ng-template>
<p-popover
        styleClass="ml-4"
        #op
        disabled="true"
        appendTo="body">

    <h3>Create Ticket</h3>

    <mvs-create-ticket-object *ngIf="showCreateTicketOverlay"
                              [objectId]="objectIdentifier?.objectId"
                              [objectAlias]="'cm.Contract'"
                              (onTicketCreation)="handleTicketCreation($event)">
    </mvs-create-ticket-object>

</p-popover>
